<template>
	<div
		class='ao-time-picker'
		:class="{ 'v-input--error': error }"
	>
		<DatePicker
			:modelValue='modelValue'
			v-bind='props'
			time-picker
			:action-row-component='actionRow'
			@update:modelValue="$emit('update:modelValue', $event)"
		/>
		<div class='v-input__details'>
			<div class='v-messages'>
				<div
					v-if='error && errorMessages'
					class='v-messages__message'
				>
					<span v-if='!Array.isArray(errorMessages)'>{{ errorMessages }}</span>
					<span v-else-if='!Array.isArray(errorMessages[0])'>{{ errorMessages[0] }}</span>
				</div>
			</div>
		</div>
		<div
			v-if='id'
			:id='id'
		/>
	</div>
</template>

<script>
import '@vuepic/vue-datepicker/dist/main.css'

import DatePicker from '@vuepic/vue-datepicker'

import ActionRow from '@/components/ui/AoDateRangePicker/ActionRow.vue'

let idx = 0

export default {
	name: 'AoTimePicker',

	components: { DatePicker },

	props: {
		modelValue: {
			type: String,
		},
		error: { type: Boolean, default: false },
		errorMessages: {
			type: Array || String,
			default: [null],
		},
		useTeleport: { type: Boolean, default: false },
	},

	emits: ['update:modelValue'],


	data() {
		return {
			id: null
		}
	},
	computed: {
		actionRow: () => ActionRow,
		props() {
			const props = {}
			if (this.useTeleport) {
				props.teleport = `#${this.id}`
				props['alt-position'] = () => ({ top: '12px', left: 0 })
				props['teleport-center'] = true
			}

			return props
		}
	},
	mounted() {
		if (this.useTeleport) {
			this.id = 'teleport' + idx
			idx += 1
		}
	},
}
</script>
<style lang='scss'>
.v-input--error {
	&.ao-time-picker {
		input {
			border: 1px solid red;
		}

		.dp__input_icon {
			color: red;
		}
	}
}
</style>
